import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import JS files

// import others files

const MediaCard = (props) => {
    const navigate = useNavigate();

  return (
    <>
      <div
        className=" relative cursor-pointer transition-all opacity-95 hover:opacity-100"
        onClick={() => navigate(`/news-content/${props.id}`)}
      >
        <div className="w-11/12   absolute top-4 left-1/2 transform -translate-x-1/2 ">
          <div className="inline-block opacity-75 py-1 md:py-2 px-2 md:px-4	 bg-mygrays-100 rounded-lg  ">
            <span className="text-xs font-bold text-myreds-100">
              {props.type}
            </span>
          </div>
        </div>
        <img src={props.img} className={props.class} />
        <div className="hidden md:block w-11/12 opacity-75 py-2 px-4	 bg-mygrays-100 rounded-lg  absolute bottom-4 left-1/2 transform -translate-x-1/2 ">
          <span className="text-xs md:text-sm font-bold text-myblacks-400 leading-8">
            {props.text}
          </span>
        </div>
        <div className="md:hidden py-2 px-4	 bg-mygrays-100 rounded-b-lg  ">
          <span className="text-xs md:text-sm font-bold text-myblacks-400 leading-8">
            {props.text}
          </span>
        </div>
      </div>
    </>
  );
};

export default MediaCard;
